import { CAPTCHA_TYPE_YANDEX } from './constants';

window.addEventListener('DOMContentLoaded', async () => {
  if (Shop.config.config.captcha_type === CAPTCHA_TYPE_YANDEX) {
    yandexCaptchaCommon.initForUIBlocks();

    return;
  }

  reCaptchaCommon.initRecaptchaUIBlocks();
});

document.addEventListener('DOMContentLoaded', function() {
  var linksForLang = document.querySelectorAll('[data-multi-lang="true"] a:not([href*="lang="]):not([href^="#"])');

  if (linksForLang.length < 500) {
    linksForLang.forEach(elem => {
      // eslint-disable-line
      var link = elem.getAttribute('href');

      if (link) {
        elem.setAttribute('href', Tools.getLinkCurrentLang(link, Tools.url.keys.lang));
      }
    });
  }

  window.addEventListener('load', function() {
    document.querySelectorAll('[data-multi-lang="true"] a:not([href*="lang="]):not([href^="#"])').forEach(elem => {
      // eslint-disable-line
      var link = elem.getAttribute('href');

      if (link) {
        elem.setAttribute('href', Tools.getLinkCurrentLang(link, Tools.url.keys.lang));
      }
    });
  });
});
